import { render } from "./prompt.vue?vue&type=template&id=b4d67aa0&scoped=true&ts=true"
import script from "./prompt.vue?vue&type=script&lang=ts"
export * from "./prompt.vue?vue&type=script&lang=ts"

import "./prompt.vue?vue&type=style&index=0&id=b4d67aa0&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d67aa0"]])

export default __exports__